import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'clientPortalAuctionUrl',
})
export class ClientPortalAuctionUrlPipe implements PipeTransform {
  baseUrl = '/houses-for-auction/direct/link/to/property/itemid';

  transform(itemId: string): any {
    return `${this.baseUrl}/${itemId}`;
  }
}
